module.exports = __webpack_public_path__ + "img/sonargroup-blog.08d4070d.webp";